import { Component, Input } from '@angular/core';

export const ERROR_CONTAINER_ID = 'error-container';

@Component({
  selector: 'app-error-icon',
  templateUrl: './error-icon.component.html',
  styleUrl: './error-icon.component.scss'
})
export class ErrorIconComponent {

  /**
   * This widget's own error message, shown on hover.
   *
   * The shared banner is deduplicated (several widgets failing for the same reason produce one
   * message), so it cannot say which widget broke — the icon's position answers "which" and this
   * tooltip answers "what".
   */
  // Requirement: the icon must scope a failure to the widget it sits beside.
  @Input() error: string;

  // Requirement: the icon is an interactive control, so it must be operable by keyboard as well as
  // mouse — it carries the only route to the error banner for a keyboard-only user.
  activateByKeyboard(event: Event) {
    // Space would otherwise scroll the page, competing with the smooth scroll below.
    event.preventDefault();
    this.scrollToErrorContainer();
  }

  scrollToErrorContainer() {

    const errorContainer = document.getElementById(ERROR_CONTAINER_ID);

    const dashboard = document.getElementsByClassName('layout-main')[0];

    if (!errorContainer) { return; }

    const elementPosition = errorContainer.getBoundingClientRect().top;

    dashboard.scrollTo({
      top: elementPosition,
      behavior: 'smooth',
    });
  }
}
